<template>
  <div id="userLoginPage">
    <h2 style="margin-bottom: 16px">创建应用</h2>
    <a-form
      :model="form"
      auto-label-width
      style="width: 480px"
      label-align="left"
      @submit="handleSubmit"
    >
      <a-form-item field="userAccount" label="应用名称">
        <a-input v-model="form.appName" placeholder="请输入应用名称" />
      </a-form-item>
      <a-form-item field="userAccount" label="应用描述">
        <a-input v-model="form.appDesc" placeholder="请输入应用描述" />
      </a-form-item>
      <a-form-item field="userAccount" label="应用图标">
        <PictureUploader
          biz="app_icon"
          :value="form.appIcon"
          :on-change="(url:string) => (form.appIcon = url)"
        ></PictureUploader>
      </a-form-item>
      <a-form-item field="userAccount" label="应用类型">
        <a-select v-model="form.appType" :style="{ width: '320px' }">
          <a-option
            v-for="(value, key) of APP_TYPE_MAP"
            :key="key"
            :value="Number(key)"
            :label="value"
          ></a-option>
        </a-select>
      </a-form-item>
      <a-form-item field="scoringStrategy" label="评分策略">
        <a-select v-model="form.scoringStrategy" :style="{ width: '320px' }">
          <a-option
            v-for="(value, key) of APP_SCORING_STRATEGY_MAP"
            :key="key"
            :value="Number(key)"
            :label="value"
          ></a-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button html-type="submit" style="width: 120px" type="primary"
          >提交</a-button
        >
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, defineProps, ref, watchEffect } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import { Message } from "@arco-design/web-vue";
import { useRouter } from "vue-router";
import API from "@/api";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import {
  addAppUsingPost,
  editAppUsingPost,
  getAppVoByIdUsingGet,
} from "@/api/appController";
import PictureUploader from "@/components/PictureUploader.vue";
const loginUserStore = useLoginUserStore();
const router = useRouter();

interface Props {
  id: string;
}

const props = withDefaults(defineProps<Props>(), {
  id: () => {
    return "";
  },
});

const form = ref({
  appDesc: "",
  appIcon: "",
  appName: "",
  appType: 0,
  scoringStrategy: 0,
} as API.AppAddRequest);

const oldApp = ref<API.AppVO>();

const loadData = async () => {
  if (!props.id) {
    return;
  }

  const res = await getAppVoByIdUsingGet({
    id: props.id as any,
  });
  if (res.data.code === 0 && res.data.data) {
    oldApp.value = res.data.data;
    form.value = res.data.data;
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

watchEffect(() => {
  loadData();
});

/*
 * 提交
 * */
const handleSubmit = async () => {
  let res: any;
  if (props.id) {
    res = await editAppUsingPost({
      id: props.id as any,
      ...form.value,
    });
  } else {
    res = await addAppUsingPost(form.value);
  }

  if (res.data.code === 0) {
    await loginUserStore.fetchLoginUser();
    Message.success("操作成功，即将跳转应用详情页");
    setTimeout(() => {
      router.push({
        path: `/app/detail/${props.id || res.data.data}`,
      });
    }, 3000);
  } else {
    Message.error("创建失败，" + res.data.message);
  }
};
</script>

<style scoped></style>
